//import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
//import { HttpModule } from '@angular/http';
//import { RouterModule }  from '@angular/router';
import { DataTableModule } from "angular2-datatable";
import { DataFilterPipe }   from "./data-filter.pipe";
import { DataUnitFilterPipe }   from "./data-unit-filter.pipe";
import { DataLevelFilterPipe }   from "./data-level-filter.pipe";
import { DataTutorFilterPipe }   from "./data-tutor-filter.pipe";
import { DataEmailFilterPipe }   from "./data-email-filter.pipe";
import { DataGroupFilterPipe }   from "./data-group-filter.pipe";
import { KeysPipe }   from "./keys.pipe";

/**
 * Modules
 */
//import { AngularFireModule, AuthProviders, AuthMethods, FirebaseApp  } from 'angularfire2';


/*
 * Components
 */
//import { AppComponent } from './app.component';
//import { AngularFireModule } from 'angularfire2';
//import { AngularFireDatabaseModule } from 'angularfire2/database';
//import { AngularFireAuthModule } from 'angularfire2/auth';
//import { environment } from '../environments/environment';
//import { CoreModule } from './core/core.module';
//import { MemberModule } from './member/member.module';
//import { WebadminModule } from './webadmin/webadmin.module';

/*
* Routing
*/
//import { AppRoutingModule }     from './routing.module';

//export const firebaseConfig = {
//  apiKey: "AIzaSyBumNr12k26GUNHQOsHrYqt4M6gqzIuiFc",
//  authDomain: "lovekid-efdc8.firebaseapp.com",
//  databaseURL: "https://lovekid-efdc8.firebaseio.com",
//  storageBucket: "lovekid-efdc8.appspot.com",
//  messagingSenderId: "861738462302"
//};

//export const firebaseAuthConfig = {
//    provider: AuthProviders.Password,
//    method: AuthMethods.Password
//};

@NgModule({
  declarations: [
    //AppComponent,
    DataFilterPipe,
    DataEmailFilterPipe,
    DataTutorFilterPipe,
    DataLevelFilterPipe,
    DataUnitFilterPipe,
    DataGroupFilterPipe,
    KeysPipe
  ],
  imports: [
  	//BrowserModule,
    //AngularFireModule.initializeApp(environment.firebase),
    //AngularFireAuthModule,
    //AngularFireDatabaseModule,
    //HttpModule,
    //AppRoutingModule,
    //CoreModule,
    //MemberModule,
    //WebadminModule,
    DataTableModule,
  ],
  exports: [
    DataFilterPipe,
    DataEmailFilterPipe,
    DataTutorFilterPipe,
    DataLevelFilterPipe,
    DataUnitFilterPipe,
    DataGroupFilterPipe,
    KeysPipe
  ]
  //providers: [],
  //bootstrap: [AppComponent]
})
export class ShareModule { }



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/share.module.ts